import * as React from "react";
import { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { InputAdornment, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Divider from "@material-ui/core/Divider";
import Card from "@material-ui/core/Card";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import GetCurrency from "../../../helper/GetCurrency";
import DeleteIcon from "@material-ui/icons/Delete";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import _ from "lodash";
import { _post } from "../../../Api";
import CircularProgress from "@material-ui/core/CircularProgress";

export const pillar_periods = ["MONTHLY", "WEEKLY", "YEARLY"];
export const pillar_invoice_types = ["BOOKING", "INCASSO"];

export default function PillarSubscriptions(props) {
  const [pillarSubscriptions, setPillarSubscriptions] = React.useState(null);
  const [editPillarSubscriptions, setEditPillarSubscriptions] = React.useState(null);
  const editable = props.editable;
  const merchantId = parseInt(useParams().merchantId);
  const merchant_type = props.merchantType;
  const toast_values = {
    position: "bottom-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const openAddDialog = () => props.setAddDialogType(merchant_type.toLowerCase());

  const openRemoveDialog = (id) => {
    props.setSelectedSubscription(id);
    props.setRemoveDialogType(merchant_type.toLowerCase());
  };

  const warning_triggered = (key, new_sub) => {
    if (
      (key === "meta number_of_pillar_users" && new_sub["number_of_pillar_users"] < 1) ||
      (key === "meta price_per_pillar_user" && new_sub["price_per_pillar_user"] < 0.01)
    ) {
      toast.error("The price cannot be zero or a negative number.", toast_values);
      return true;
    }
    if (
      new_sub["subscription_stopped"] &&
      new Date(new_sub["subscription_started"]) > new Date(new_sub["subscription_stopped"])
    ) {
      toast.error("End date has to be later than start date", toast_values);
      return true;
    }
  };

  const initializePillarSubscriptions = () => {
    const subs = props.subscriptions.filter((sub) => sub.type === merchant_type);
    setPillarSubscriptions(_.cloneDeep(subs));
    setEditPillarSubscriptions(_.cloneDeep(subs));
  };
  useEffect(initializePillarSubscriptions, []);

  const postPillarSubscriptions = (id, key, value = null) => {
    const mapping = {
      T: "ta_merchant_id",
      S: "sp_merchant_id",
      P: "pillar_merchant_id",
    };
    const oldsub = pillarSubscriptions.find((sub) => sub.id === id);
    const newsub = editPillarSubscriptions.find((sub) => sub.id === id);
    let data;
    let equal = key.includes("meta")
      ? oldsub["meta"][key.replace("meta ", "")] === newsub["meta"][key.replace("meta ", "")]
      : oldsub[key] === newsub[key];
    if (key === "merchant_id") {
      equal = oldsub[mapping[value[0]]] === newsub[mapping[value[0]]];
      data = {
        [mapping[value[0]]]: parseInt(newsub[mapping[value[0]]]),
      };
    } else if (key.includes("meta")) {
      data = {
        [key.replace("meta ", "")]: newsub["meta"][key.replace("meta ", "")],
      };
    } else {
      data = {
        [key]: newsub[key],
      };
    }
    if (equal || warning_triggered(key, newsub)) return;
    _post("/nova/merchant/" + merchantId + "/subscription/" + id, data)
      .then(() => {
        toast.success(`Saved ${merchant_type} subscriptions successfully!`, toast_values);
        setPillarSubscriptions(editPillarSubscriptions);
      })
      .catch((error) => {
        console.log(error);
        toast.error(`${merchant_type} subscriptions could not be saved.`, toast_values);
      });
  };

  const changePillarSubscriptions = (id, key, value) => {
    if (id == null || editPillarSubscriptions == null) return;
    const subs = _.cloneDeep(editPillarSubscriptions);
    const currentSub = subs.findIndex((sub) => sub.id === id);
    if (key === "wefact_merchant") {
      subs[currentSub]["wefact_merchant"] = props.wefactMerchants.find((merchant) => merchant.id === value);
    } else if (key.includes("meta")) {
      subs[currentSub]["meta"][key.replace("meta ", "")] = value;
    } else {
      subs[currentSub][key] = value;
    }
    setEditPillarSubscriptions(subs);
  };

  if (
    merchant_type == null ||
    props.subscriptions == null ||
    editPillarSubscriptions == null ||
    props.wefactMerchants == null
  ) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Grid container direction="column" spacing={4}>
      <Grid container direction="row" spacing={2} style={{ marginTop: "20px" }}>
        <Grid item>
          <Typography variant={"h5"}>{merchant_type}</Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            disabled={!editable}
            onClick={openAddDialog}
            startIcon={<AddIcon />}
            color="primary"
          >
            Subscription
          </Button>
        </Grid>
      </Grid>
      <Divider style={{ margin: "20px 0" }} />
      {editPillarSubscriptions.map((subscription) => {
        if (editable) {
          return (
            <Grid item key={subscription.id}>
              <Card style={{ padding: "1em" }}>
                <Grid container direction={"row"} spacing={3}>
                  <Grid item>
                    <FormControl>
                      <InputLabel>debtor</InputLabel>
                      <Select
                        value={subscription.wefact_merchant_id}
                        onBlur={() => postPillarSubscriptions(subscription.id, "wefact_merchant")}
                        onChange={(event) =>
                          changePillarSubscriptions(subscription.id, "wefact_merchant", event.target.value)
                        }
                      >
                        {props.wefactMerchants.map((merchant) => {
                          return <MenuItem value={merchant.id}>{merchant.debtor_code + " " + merchant.name}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    {(() => {
                      if (merchant_type.includes("PILLAR")) {
                        return (
                          <FormControl>
                            <InputLabel>merchant</InputLabel>
                            <Select
                              value={"P" + subscription.pillar_merchant_id}
                              onBlur={() => postPillarSubscriptions(subscription.id, "pillar_merchant_id")}
                              onChange={(event) =>
                                changePillarSubscriptions(
                                  subscription.id,
                                  "pillar_merchant_id",
                                  event.target.value.slice(1)
                                )
                              }
                            >
                              {(() => {
                                if (props.merchant.pillar_merchants) {
                                  return props.merchant.pillar_merchants.map((pillar_merchant) => {
                                    return (
                                      <MenuItem value={"P" + pillar_merchant.id}>{"P" + pillar_merchant.id}</MenuItem>
                                    );
                                  });
                                }
                                return <div />;
                              })()}
                            </Select>
                          </FormControl>
                        );
                      }
                    })()}
                  </Grid>
                  <Grid item>
                    <TextField
                      label="title"
                      value={subscription.name}
                      onBlur={() => postPillarSubscriptions(subscription.id, "name")}
                      onChange={(event) => changePillarSubscriptions(subscription.id, "name", event.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="start date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) =>
                        changePillarSubscriptions(subscription.id, "subscription_started", event.target.value)
                      }
                      onBlur={() => postPillarSubscriptions(subscription.id, "subscription_started")}
                      value={(() => {
                        const index = subscription.subscription_started.indexOf("T");
                        return index > -1
                          ? subscription.subscription_started.slice(0, index)
                          : subscription.subscription_started;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="end date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) =>
                        changePillarSubscriptions(subscription.id, "subscription_stopped", event.target.value)
                      }
                      onBlur={() => postPillarSubscriptions(subscription.id, "subscription_stopped")}
                      value={(() => {
                        if (subscription.subscription_stopped == null) return "";
                        const index = subscription.subscription_stopped.indexOf("T");
                        return index > -1
                          ? subscription.subscription_stopped.slice(0, index)
                          : subscription.subscription_stopped;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <FormControl>
                      <InputLabel>period</InputLabel>
                      <Select
                        value={subscription.period}
                        onBlur={() => postPillarSubscriptions(subscription.id, "period")}
                        onChange={(event) => changePillarSubscriptions(subscription.id, "period", event.target.value)}
                      >
                        {pillar_periods.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl>
                      <InputLabel>invoice type</InputLabel>
                      <Select
                        value={subscription.invoice_type}
                        onBlur={() => postPillarSubscriptions(subscription.id, "invoice_type")}
                        onChange={(event) =>
                          changePillarSubscriptions(subscription.id, "invoice_type", event.target.value)
                        }
                      >
                        {pillar_invoice_types.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        changePillarSubscriptions(subscription.id, "subscription_stopped", null);
                      }}
                      onBlur={() => {
                        postPillarSubscriptions(subscription.id, "subscription_stopped");
                      }}
                    >
                      Empty end date
                    </Button>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined">
                      <InputLabel>number suffix</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        labelWidth={60}
                        onBlur={() => postPillarSubscriptions(subscription.id, "meta number_suffix")}
                        onChange={(event) =>
                          changePillarSubscriptions(subscription.id, "meta number_suffix", event.target.value)
                        }
                        value={subscription.meta.number_suffix}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined">
                      <InputLabel>price per pillar user</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                        labelWidth={60}
                        onBlur={() => postPillarSubscriptions(subscription.id, "meta price_per_pillar_user")}
                        onChange={(event) =>
                          changePillarSubscriptions(
                            subscription.id,
                            "meta price_per_pillar_user",
                            event.target.value ? parseFloat(event.target.value) : null
                          )
                        }
                        value={subscription.meta.price_per_pillar_user}
                        inputProps={{
                          min: 0,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined">
                      <InputLabel>number of pillar users</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        labelWidth={60}
                        onBlur={() => postPillarSubscriptions(subscription.id, "meta number_of_pillar_users")}
                        onChange={(event) =>
                          changePillarSubscriptions(
                            subscription.id,
                            "meta number_of_pillar_users",
                            event.target.value ? parseInt(event.target.value) : null
                          )
                        }
                        value={subscription.meta.number_of_pillar_users}
                        inputProps={{
                          min: 0,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <Button startIcon={<DeleteIcon />} onClick={() => openRemoveDialog(subscription.id)} />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          );
        } else {
          return (
            <Grid item key={subscription.id}>
              <Card style={{ padding: "1em" }}>
                <Grid container direction={"row"} spacing={3}>
                  <Grid item>
                    <FormControl disabled>
                      <InputLabel>debtor</InputLabel>
                      <Select
                        value={subscription.wefact_merchant_id}
                        onBlur={() => postPillarSubscriptions(subscription.id, "wefact_merchant")}
                        onChange={(event) =>
                          changePillarSubscriptions(subscription.id, "wefact_merchant", event.target.value)
                        }
                      >
                        {props.wefactMerchants.map((merchant) => {
                          return <MenuItem value={merchant.id}>{merchant.debtor_code + " " + merchant.name}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    {(() => {
                      if (merchant_type.includes("PILLAR")) {
                        return (
                          <FormControl disabled>
                            <InputLabel>merchant</InputLabel>
                            <Select
                              value={"P" + subscription.pillar_merchant_id}
                              onChange={(event) =>
                                changePillarSubscriptions(
                                  subscription.id,
                                  "pillar_merchant_id",
                                  event.target.value.slice(1)
                                )
                              }
                            >
                              {(() => {
                                if (props.merchant.pillar_merchants) {
                                  return props.merchant.pillar_merchants.map((pillar_merchant) => {
                                    return <MenuItem value={pillar_merchant.id}>{"T" + pillar_merchant.id}</MenuItem>;
                                  });
                                }
                                return <div />;
                              })()}
                            </Select>
                          </FormControl>
                        );
                      }
                    })()}
                  </Grid>
                  <Grid item>
                    <TextField
                      label="title"
                      value={subscription.name}
                      disabled
                      onBlur={() => postPillarSubscriptions(subscription.id, "name")}
                      onChange={(event) => changePillarSubscriptions(subscription.id, "name", event.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="start date"
                      type="date"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      onChange={(event) =>
                        changePillarSubscriptions(subscription.id, "subscription_started", event.target.value)
                      }
                      onBlur={() => postPillarSubscriptions(subscription.id, "subscription_started")}
                      value={(() => {
                        const index = subscription.subscription_started.indexOf("T");
                        return index > -1
                          ? subscription.subscription_started.slice(0, index)
                          : subscription.subscription_started;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      label="end date"
                      type="date"
                      disabled
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) =>
                        changePillarSubscriptions(subscription.id, "subscription_stopped", event.target.value)
                      }
                      onBlur={() => postPillarSubscriptions(subscription.id, "subscription_stopped")}
                      value={(() => {
                        if (subscription.subscription_stopped == null) return "";
                        const index = subscription.subscription_stopped.indexOf("T");
                        return index > -1
                          ? subscription.subscription_stopped.slice(0, index)
                          : subscription.subscription_stopped;
                      })()}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item>
                    <FormControl disabled>
                      <InputLabel>period</InputLabel>
                      <Select
                        value={subscription.period}
                        onBlur={() => postPillarSubscriptions(subscription.id, "period")}
                        onChange={(event) => changePillarSubscriptions(subscription.id, "period", event.target.value)}
                      >
                        {pillar_periods.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl disabled>
                      <InputLabel>invoice type</InputLabel>
                      <Select
                        value={subscription.invoice_type}
                        onBlur={() => postPillarSubscriptions(subscription.id, "invoice_type")}
                        onChange={(event) =>
                          changePillarSubscriptions(subscription.id, "invoice_type", event.target.value)
                        }
                      >
                        {pillar_invoice_types.map((period) => {
                          return <MenuItem value={period}>{period}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      disabled
                      color="primary"
                      onClick={() => {
                        changePillarSubscriptions(subscription.id, "subscription_stopped", null);
                      }}
                      onBlur={() => {
                        postPillarSubscriptions(subscription.id, "subscription_stopped");
                      }}
                    >
                      Empty end date
                    </Button>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined" disabled>
                      <InputLabel>number suffix</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        labelWidth={60}
                        onBlur={() => postPillarSubscriptions(subscription.id, "meta number_suffix")}
                        onChange={(event) =>
                          changePillarSubscriptions(subscription.id, "meta number_suffix", event.target.value)
                        }
                        value={subscription.meta.number_suffix}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined" disabled>
                      <InputLabel>price per pillar user</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                        labelWidth={60}
                        onBlur={() => postPillarSubscriptions(subscription.id, "meta price_per_pillar_user")}
                        onChange={(event) =>
                          changePillarSubscriptions(
                            subscription.id,
                            "meta price_per_pillar_user",
                            event.target.value ? parseFloat(event.target.value) : null
                          )
                        }
                        value={subscription.meta.price_per_pillar_user}
                        inputProps={{
                          min: 0,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <FormControl variant="outlined" disabled>
                      <InputLabel>number of pillar users</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        labelWidth={60}
                        onBlur={() => postPillarSubscriptions(subscription.id, "meta number_of_pillar_users")}
                        onChange={(event) =>
                          changePillarSubscriptions(
                            subscription.id,
                            "meta number_of_pillar_users",
                            event.target.value ? parseInt(event.target.value) : null
                          )
                        }
                        value={subscription.meta.number_of_pillar_users}
                        inputProps={{
                          min: 0,
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <Button startIcon={<DeleteIcon />} onClick={() => openRemoveDialog(subscription.id)} />
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          );
        }
      })}
    </Grid>
  );
}
